<template>
  <div class="person_group_selector_container">
    <multiselect :disabled="disabled" required="true" v-model="selected_person_group"  @select="handleSelection" :options="people_groups" placeholder="Select one" label="value" track-by="value"></multiselect>
    <multiselect :disabled="disabled" v-if="selected_person_group.key=='employee_by_typology'" @select="handleSelectionSubsequentSelection" v-model="subsequentInfo" :options="employee_typologies" placeholder="Select one" label="name" track-by="name"></multiselect>
    <multiselect :disabled="disabled" v-if="selected_person_group.key=='employee_by_organizational_unit'" @select="handleSelectionSubsequentSelection" v-model="subsequentInfo" :options="organizational_units" placeholder="Select one" label="name" track-by="name"></multiselect>
    <multiselect :disabled="disabled" v-if="selected_person_group.key=='employee_by_headquarter'" @select="handleSelectionSubsequentSelection" v-model="subsequentInfo" :options="headquarters" placeholder="Select one" label="name" track-by="name"></multiselect>
    <vue-datepicker
        v-if="['employee_after_date', 'employee_before_date'].indexOf(selected_person_group.key) >= 0"
        input_class="form-control"
        :input_name="getName('subsequent')"
        :input_value="subsequentInfo.date"
    ></vue-datepicker>
    <input type="hidden" :name="getName('main')" :value="this.selected_person_group.key">
    <input type="hidden" v-if="['employee_after_date', 'employee_before_date'].indexOf(selected_person_group.key) < 0" :name="getName('subsequent')" :value="this.selectedSubsequentInfo">
  </div>
</template>

<script>
  export default {
  	data () {
      return {
      	selected_person_group: {},
        selectedSubsequentInfo: "",
        subsequentInfo: {},
        selectedPerson: {},
      }
  	},

    methods: {
      getName(element) {
        if (element == "main") return this.main_name;
        else if (element == "subsequent") return this.subsequent_name;
      },
      handleSelection(selectedOption) {
        this.selectedSubsequentInfo = "";
        console.log(selectedOption.key);
      },
      handleSelectionSubsequentSelection(selectedOption) {
        this.selectedSubsequentInfo = selectedOption.id;
        console.log("subsequentVal: ", this.selectedSubsequentInfo);
      }
    },
    mounted() {
      this.selected_person_group = this.selected_person_group_from_db;
      this.subsequentInfo = this.selected_subsequent_person_group_from_db;
      console.log(this.subsequentInfo);
    },

    props: {
    	people_groups: {
    		type: Array,
    		required: true
    	},
      organizational_units: {
        type: Array,
        required: true
      },
      headquarters: {
        type: Array,
        required: true
      },
      employee_typologies: {
        type: Array,
        required: true
      },
      selected_person_group_from_db: {
        type: Object,
        required: true,
      },
      selected_subsequent_person_group_from_db: {
        type: Object,
        required: true,
      },
      disabled: {
        type: Boolean,
        requried: true
      },
      main_name: {
        type: String,
        requried: true
      },
      subsequent_name: {
        type: String,
        requried: true
      }
    }

  }
</script>
<style>
  .person_group_selector_container {
    width: 100%;
  }
</style>

